export const InitToast = {
  mounted() {
    init.bind(this)()
  },
  updated() {
    init.bind(this)()
  }
}

function init() {
  let toastEl = this.el
  if (toastEl && toastEl.innerText !== '') {
    toastEl.classList.add("mr-4")

    setTimeout(() => {
      toastEl.classList.toggle("-mr-64", "mr-4")
      //toastEl.classList.toggle("opacity-0")
      setTimeout(() => this.pushEvent("lv:clear-flash", "", () =>{}) , 300)
    }, 3000);
  }
}

